/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lesson_HappenedInputs */

const en_lesson_happened = /** @type {(inputs: Lesson_HappenedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Happened`)
};

const he_lesson_happened = /** @type {(inputs: Lesson_HappenedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`התקיים`)
};

/**
* | output |
* | --- |
* | "Happened" |
*
* @param {Lesson_HappenedInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const lesson_happened = /** @type {((inputs?: Lesson_HappenedInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lesson_HappenedInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lesson_happened(inputs)
	return he_lesson_happened(inputs)
});